/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/salary',
  name: 'Salary',
  component: () => import('@/views/salary/Index'),
},
]
